<template>
    <div class="" id="">
        <section class="modal_back_caa">
            <div class="is-flex is-flex-direction-row mt-2 mb-4 gap-custom">
                <div v-if="counterpart.obligation_name != 'finiquitos-clf'" class="card-custom is-flex-grow-1">
                    <p class="header-card">Clasificación por contraparte</p>
                    <p class="progressTextContent">
                        <span class="numberProgress">
                            {{ getNumberClassifiedByCounterpart }} /
                            {{ getNumberTotalDocuments }}
                        </span>
                        <span class="textProgress">Clasificados</span>
                    </p>
                    <div class="progress-container">
                        <div class="progress-bar"
                            :style="{ width: getNumberClassifiedByCounterpart / getNumberTotalDocuments * 100 + '%' }">
                        </div>
                    </div>
                </div>
                <div class="card-custom is-flex-grow-1">
                    <p class="header-card">Clasificación por documento</p>
                    <p class="progressTextContent">
                        <span class="numberProgress">
                            {{ getNumberClassifiedByDocument }} /
                            {{ getNumberTotalDocuments }}
                        </span>
                        <span class="textProgress">Clasificados</span>
                    </p>
                    <div class="progress-container">
                        <div class="progress-bar"
                            :style="{ width: getNumberClassifiedByDocument / getNumberTotalDocuments * 100 + '%' }">
                        </div>
                    </div>
                </div>
            </div>

            <div class="is-flex is-flex-direction-row is-flex-grow-1 mb-3">
                <div class="is-flex-grow-2">
                    <div class="header_title">
                        Clasificar por documentos
                    </div>
                    <div class="header_subtitle">
                        Clasifica de forma individual o por lotes para mayor eficiencia
                    </div>
                </div>
            </div>

            <div class="counterpart_table_header">
                <div class="search_container">
                    <div class="">
                        <p class="absolute-box ">
                            <span class="absolute-pos icon-left">
                                <SearchIcon />
                            </span>

                            <input class="absolute-pos input-center" type="text"
                                placeholder="Buscar por número de documento" v-model="searchFilter" />
                            <span v-if="searchFilter" class="absolute-pos icon-right clear_button"
                                @click="searchFilter = ''">
                                <Ecs class="icon is-small is-right ecs" />
                            </span>
                        </p>
                    </div>
                </div>
                <div class="filter_container">
                    <SimpleButton @click="() => { this.filterTable = 'all'; allFiltersToEntries() }"
                        class="select_button  first_button nobreak"
                        v-bind:class="{ black_button: filterTable === 'all' }">
                        Ver Todos
                    </SimpleButton>
                    <SimpleButton @click="() => { this.filterTable = 'Sin Clasificar'; allFiltersToEntries() }"
                        class="select_button nobreak" v-bind:class="{
                            black_button: filterTable === 'Sin Clasificar',
                        }">
                        🔍 Sin Clasificar
                    </SimpleButton>
                    <SimpleButton @click="() => { this.filterTable = 'Contraparte'; allFiltersToEntries() }"
                        class="select_button nobreak" v-bind:class="{ black_button: filterTable === 'Contraparte' }">
                        Por Contraparte
                    </SimpleButton>
                    <SimpleButton @click="() => { this.filterTable = 'Documento'; allFiltersToEntries() }"
                        class="select_button last_button nobreak"
                        v-bind:class="{ black_button: filterTable === 'Documento' }">
                        Por Documento
                    </SimpleButton>
                </div>
            </div>

            <div class="container_table_main_table main_table">
                <table class="big_table color_gray_text">
                    <colgroup>
                        <col style="width: 3%" />
                        <col v-for="header in selectedHeaderDocsTable.headers" v-bind:key="header.key"
                            :style="'width: ' + header.width + '%;'" />
                        <col style="width: 2%" />
                    </colgroup>
                    <tr>
                        <td class="py-3 px-2 ">
                            <div class="mt-1 ml-2 checkboxes is-clickable">
                                <label for="allSelected">
                                    <input class="checkSize" type="checkbox" @change="onChangeAllCheck($event.target)"
                                        v-model="allSelected" name="allSelected" id="allSelected">
                                </label>
                            </div>
                        </td>
                        <td class="py-3 px-2 is-vcentered" v-for="header in selectedHeaderDocsTable.headers"
                            v-bind:key="header.label">
                            <span class="table_header_title ml-2 is-justify-content-center nobreak"
                                :class="{ sortable_header: header.key }"
                                @click="header.key && changeOrderGeneric(header.key)">
                                <span class="header_label">{{ header.label }}</span>
                                <!-- Indicador de orden: siempre presente y sin encogerse, para
                                    que etiquetas largas en columnas angostas no lo tapen. El click
                                    lo maneja el header completo (burbujea desde el botón). -->
                                <SortButton class="ml-1 sort_btn"
                                    :globalSortColumn="sortColumn" :column="header.key" :sortDirection="sortDirection">
                                </SortButton>
                            </span>
                        </td>
                        <td></td>
                    </tr>
                    <template v-for="(entry, iEntry) in getPaginatedList">
                        <tr :class="['counterpart_row', { 'is-disabled-local': entry.cancelled, 'is-classifying': entry.isClassifying }]"
                            v-show="entry.visible" v-bind:key="entry.td_id">
                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="mt-1 ml-2 checkboxes">
                                    <label for="selected">
                                        <input class="checkSize is-clickable" type="checkbox" v-model="entry.selected"
                                            name="selected" id="selected" :disabled="entry.cancelled">
                                    </label>
                                </div>
                            </td>


                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <span class="nobreak is-capitalized attribute_name">
                                    {{
                                        getFormattedDate(entry.emitted_at,
                                            selectedHeaderDocsTable.headers[0].formatDate).replace('.', '')
                                    }}
                                </span>
                            </td>

                            <td class="py-3 px-2 is-vcentered"
                                :class="{ 'is-disabled-local': entry.accounts.length == 0, 'is-clickable': entry.accounts.length > 0 }"
                                @click="openAccrualModal(iEntry)">
                                <div class="is-flex is-justify-content-center" v-if="!entry.has_accrual">
                                    <span class="is-capitalized nobreak attribute_name is-align-content-center">
                                        {{
                                            getFormattedDate(entry.emitted_at,
                                                selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                        }}
                                    </span>
                                    <span>
                                        <CalendarMinus class="iconAlign" />
                                    </span>
                                </div>

                                <div v-else class="is-flex is-flex-direction-row is-justify-content-center">
                                    <span class="mr-2 attribute_name">
                                        <p class="is-capitalized"> {{
                                            getFormattedDate(entry.init_accrual,
                                                selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                        }}
                                        </p>
                                        <p v-if="entry.init_accrual != entry.end_accrual" class="is-capitalized">
                                            {{
                                                getFormattedDate(entry.end_accrual,
                                                    selectedHeaderDocsTable.headers[1].formatDate).replace('.', '')
                                            }}
                                        </p>
                                    </span>
                                    <span class="is-align-self-center">
                                        <CalendarCheck class="iconAlign" />
                                    </span>
                                </div>
                            </td>

                            <template v-for="(header, iHeader) in selectedHeaderDocsTable.headers">
                                <td v-if="iHeader > 1 && !['mother_account', 'accounts', 'attribute'].includes(header.key)"
                                    v-bind:key="header.label"
                                    class="py-3 px-2 is-vcentered has-text-centered attribute_name">
                                    <span v-if="header.key == 'amount'">{{ money(entry.amount) }}</span>
                                    <span v-else>{{ entry[header.path] }}</span>
                                </td>
                            </template>

                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="square_pill pill_sin_clasificar nobreak"
                                    v-if="!entry.accounts || !entry.accounts.length || entry.cancelled">
                                    <span v-if="!entry.cancelled">Sin Clasificar</span>
                                    <span v-if="entry.cancelled && entry.doc_type != 'Boleta de Honorarios'">
                                        Anulado por NC: {{ entry.nc_doc_number }}
                                    </span>
                                    <span v-if="entry.cancelled && entry.doc_type == 'Boleta de Honorarios'">
                                        Anulada
                                    </span>
                                </div>
                                <div v-if="!entry.cancelled" class="is-vcentered has-text-centered">
                                    <span class="square_pill pill_mother_account grey_pill nobreak d"
                                        v-for="(mother_account, index) in entry.mother_accounts" v-bind:key="index">
                                        {{ mother_account }}
                                    </span>
                                </div>
                                
                            </td>

                            <td class="py-3 px-2 is-vcentered has-text-centered">
                                <div class="is-flex is-flex-direction-row is-justify-content-center is-flex-wrap-wrap">
                                    <div class="square_pill pill_mother_account white_pill nobreak"
                                        v-for="account in entry.accounts" v-bind:key="account.level_3">
                                        {{ account.level_3 }}
                                    </div>
                                    <div v-if="!entry.cancelled && (!entry.accounts || !entry.accounts.length)"
                                        class="is-full-width is-flex is-justify-content-center">
                                        <span @click="openClassifyTree(iEntry)"
                                            class="square_pill pill_clasificar is-clickable">
                                            <EditPencil class="edit_pencil" />
                                            Clasificar
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <td class="py-3 px-2 is-vcentered">
                                <div v-for="(type, index) in types" v-bind:key="index" class="mt-1">
                                    <p v-if="entry.attribute[type]" class="is-capitalized attribute_name">{{ type }}:
                                    </p>
                                    <div v-for="(attrib, iAttrib) in entry.attribute[type]" v-bind:key="iAttrib">
                                        <span
                                            :class="['circle_pill', { 'blue_pill': index == 0 }, { 'purple_pill': index == 1 }, 'is-capitalized', 'nobreak']"
                                            v-if="entry.attribute[type].findIndex(att => att.name == attrib.name) == iAttrib">
                                            {{ attrib.name }}
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <td class="py-3 px-2 is-vcentered has-text-centered is-clickable"
                                v-if="counterpart.obligation_name != 'finiquitos-clf' && !entry.cancelled"
                                @click="openClassifyTree(iEntry)">
                                <EditPencil class="mr-1" />
                            </td>
                        </tr>
                        <tr class="counterpart_row" v-bind:key="'extra' + entry.td_id" v-if="entry.isClassifying">
                            <td colspan="10">
                                <div class="p-5 content-tree">
                                    <TreeClassification :classifiedAccounts="selectedClassifiedAccounts"
                                        :accounts="accounts" :types="types"
                                        :classifiedAttributes="selectedClassifiedAttributes"
                                        :allAttributes="allAttributes" :documentType="counterpart.pay_or_charge"
                                        :contraparteId="counterpart.ci_id" :documentsIds="selectedDocumentsIds"
                                        :money="entry.amount" :obligationName="counterpart.obligation_name"
                                        @closeTree="() => closeClassifyTree()" @reloadDocs="() => $emit('reloadDocs')"
                                        key="prorateEditKey1" />
                                </div>
                            </td>
                        </tr>
                    </template>

                </table>
            </div>
            <Pagination class="mt-3" v-model="actualPage" :maxPages="maxPages" />
        </section>
    </div>
</template>


<script>
import {
    get_prorates_x_company_involved
} from "@/api/carteraAnalista";
import ChangeAccrual from "@/components/classification/modals/ChangeAccrual";
import TreeClassification from "@/components/classification/TreeClassificator.vue";
import SimpleButton from "@/components/modals/SimpleButton.vue";
import SortButton from "@/components/modals/SortButton.vue";
import Pagination from "@/components/generics/Pagination";
import CalendarCheck from "@/components/svg/CalendarCheck.vue";
import CalendarMinus from "@/components/svg/CalendarMinus.vue";
import Ecs from "@/components/svg/Ecs.vue";
import EditPencil from "@/components/svg/EditPencil.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";
import { parseToMoney } from "@/utils/currency";
import { notificate } from "@/utils/message";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
    name: "ClassifyDocuments",
    components: {
        Ecs,
        EditPencil,
        SearchIcon,
        SimpleButton,
        SortButton,
        TreeClassification,
        CalendarCheck,
        CalendarMinus,
        Pagination
    },
    data() {
        return {
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
            //-----
            filterTable: 'all',
            orderedEntries: [],
            searchFilter: "",
            sortColumn: "order",
            sortDirection: "",
            allSelected: false,
            selectedClassifiedAttributes: [],
            selectedClassifiedAccounts: [],
            selectedDocumentsIds: [],
            actualPage: 1,
            itemsPerPage: 10,
            // One-shot del deep-link: se consume en el primer rebuild de
            // orderedEntries con datos, para no secuestrar interacciones
            // posteriores del usuario (sorts/filtros/reloads).
            autoOpenConsumed: false,
        };
    },
    methods: {
        ...mapActions("classification", ["setSelectedHeaderDocTable",
            "setEmptyDocuments"]),
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            }
        },
        onChangeAllCheck({ checked }) {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.selected = checked
                return entry
            })
        },
        openAccrualModal(initialPos) {
            if (this.getPaginatedList.at(initialPos).cancelled) {
                return
            }

            const foundEntry = this.orderedEntries.find(entry=> entry.td_id == this.getPaginatedList.at(initialPos).td_id)
            if(foundEntry){
                foundEntry.selected = true
            }
            const allDocsSelected = this.getDocsSelected()

            this.$buefy.modal.open({
                ...this.modalDefault,
                component: ChangeAccrual,
                canCancel: ["escape", "button", "outside"],
                props: {
                    titleModal: this.counterpart.alias,
                    subTitleModal: this.counterpart.rut,
                    documentType: this.counterpart.pay_or_charge,
                    documents: allDocsSelected,
                },
                events: {
                    save_accrual: ({ docs_ids, start_dates, end_dates }) => {
                        this.orderedEntries = this.orderedEntries.map(orderEntry => {
                            const docIdSearched = docs_ids.indexOf(orderEntry.td_id)
                            if (docIdSearched >= 0) {
                                orderEntry.has_accrual = true
                                orderEntry.init_accrual = moment(start_dates[docIdSearched]).format('YYYY-MM-DD')
                                orderEntry.end_accrual = moment(end_dates[docIdSearched]).format('YYYY-MM-DD')
                            }
                            orderEntry.selected = false
                            return orderEntry
                        })
                    },
                    close: () => {
                    }
                },
            });
        },
        getDocsSelected() {
            // this.orderedEntries[initialPos]['selected'] = true;
            // this.orderedEntries = [...this.orderedEntries];
            const allDocsSelected = this.orderedEntries.filter(entry => {
                return entry.selected
            })
            return allDocsSelected
        },
        initLoadClassificationData(data) {
            const prorate_x_account = data['prorate_x_account'];
            const prorates_x_attribute = data['prorates_x_attribute'];

            this.selectedClassifiedAttributes = [...prorates_x_attribute];
            this.selectedClassifiedAccounts = []
            for (const pxa of prorate_x_account) {
                this.selectedClassifiedAccounts.push({ id: Number(pxa.id), percentage: pxa.percentage, account: Number(pxa.classified_account) });
            }
            if (this.selectedClassifiedAccounts.length == 0) {
                this.selectedClassifiedAccounts = [...this.classifiedAccounts]
                this.selectedClassifiedAttributes = [...this.classifiedAttributes]
            }
        },
        async openClassifyTree(iDocument) {
            const { data } = await get_prorates_x_company_involved(
                this.counterpart.ci_id, this.getPaginatedList[iDocument].td_id,
                this.counterpart.pay_or_charge, this.counterpart.obligation_name);
            this.initLoadClassificationData(data)

            const foundEntry = this.orderedEntries.find(entry=> entry.td_id == this.getPaginatedList.at(iDocument).td_id)
            if(foundEntry){
                foundEntry.selected = true
            }

            const allDocsSelected = this.getDocsSelected()
            this.selectedDocumentsIds = allDocsSelected.map(docSelected => docSelected.td_id)
            const doc = this.getPaginatedList[iDocument]
            this.orderedEntries = this.orderedEntries.map(entry => {
                if (entry.td_id == doc.td_id) {
                    entry.isClassifying = true
                } else {
                    entry.isClassifying = false
                }
                return entry
            })
        },
        closeClassifyTree() {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.isClassifying = false
                entry.selected = false
                return entry
            })
        },
        // Deep-link desde reportes: cuando orderedEntries se puebla, busca el
        // doc pedido, salta a su página, abre su árbol de prorrateo y lo
        // scrollea a la vista (el scroll burbujea al contenedor del modal).
        async maybeAutoOpen() {
            if (!this.autoOpenDocId || this.autoOpenConsumed) return;
            const visibles = this.orderedEntries.filter(entry => entry.visible)
            if (visibles.length == 0) return; // docs aún no cargados — esperar
            // Esperar el set ENRIQUECIDO (setExtraInfoDocumentsByCounterpart
            // agrega mother_accounts): los buckets —y por lo tanto la página
            // del doc— se calculan distinto sobre el set crudo (un doc
            // clasificado por contraparte ahí no tiene accounts todavía).
            if (visibles[0].mother_accounts === undefined) return;
            this.autoOpenConsumed = true;
            const idx = visibles.findIndex(entry => entry.td_id == this.autoOpenDocId)
            if (idx < 0 || visibles[idx].cancelled) {
                notificate(
                    `<strong>Atención</strong><br>
                    El documento no está disponible en el período cargado.`,
                    "is-warning is-light"
                );
                return;
            }
            this.actualPage = Math.floor(idx / this.itemsPerPage) + 1;
            await this.openClassifyTree(idx % this.itemsPerPage);
            await this.$nextTick();
            const treeEl = this.$el.querySelector(".content-tree");
            if (treeEl && treeEl.scrollIntoView) {
                treeEl.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
        changeFilterTable(entry) {
            switch (this.filterTable) {
                case "all":
                    return true;
                case "Sin Clasificar":
                    return entry.accounts.length == 0
                case "Contraparte":
                    return entry.is_classified_by_counterpart
                case "Documento":
                    return !entry.is_classified_by_counterpart && entry.accounts.length > 0
                default:
                    return false
            }
            // entry.isClassifying = false
        },
        changeDirectionData() {
            if (this.sortDirection == "order") {
                this.sortDirection = "desc";
            } else if (this.sortDirection == "desc") {
                this.sortDirection = "asc";
            } else if (this.sortDirection == "asc") {
                this.sortDirection = "order";
                this.sortColumn = "order";
            }
        },
        // Valor comparable de una fila para la columna activa. Centralizar el
        // acceso acá hace que CUALQUIER columna sea ordenable con el mismo
        // comparador, sin un branch por columna. Devuelve número (fechas/monto)
        // o string en minúscula (texto y columnas derivadas de pills).
        sortValue(entry, key) {
            switch (key) {
                case "emitted_at":
                    return new Date(entry.emitted_at).getTime() || 0;
                case "accrual":
                    // Mes Devengo: inicio del devengo si existe; si no, la fecha
                    // de emisión (mismo dato que muestra la celda).
                    return new Date(
                        entry.has_accrual ? entry.init_accrual : entry.emitted_at
                    ).getTime() || 0;
                case "amount":
                    return Number(entry.amount) || 0;
                case "doc_number":
                    return entry.doc_number == null ? "" : String(entry.doc_number);
                case "doc_type":
                    return (entry.doc_type || "").toLowerCase();
                case "rut":
                    return (entry.rut || "").toLowerCase();
                case "description":
                    return (entry.description || "").toLowerCase();
                case "alias":
                    return (entry.alias || "").toLowerCase();
                case "mother_account": {
                    const arr = entry.mother_accounts || [];
                    return arr.length ? String(arr[0]).toLowerCase() : "";
                }
                case "accounts": {
                    const arr = entry.accounts || [];
                    return arr.length ? String(arr[0].level_3 || "").toLowerCase() : "";
                }
                case "attribute": {
                    const firstType = this.types && this.types[0];
                    const items = firstType && entry.attribute ? entry.attribute[firstType] : null;
                    return items && items.length ? String(items[0].name || "").toLowerCase() : "";
                }
                default:
                    return "";
            }
        },
        // Resta para números; localeCompare (es, numeric) para strings — así
        // "Doc 2" < "Doc 10" y respeta acentos de forma estable.
        compareSortValues(x, y) {
            if (typeof x === "number" && typeof y === "number") return x - y;
            return String(x).localeCompare(String(y), "es", { numeric: true, sensitivity: "base" });
        },
        sortPartiallyDocs(docsToSort = []) {
            // Estado "order" (3er click / default): se respeta el orden original
            // (sort estable) para volver a la vista por defecto.
            if (this.sortDirection !== "asc" && this.sortDirection !== "desc") {
                return docsToSort;
            }
            const dir = this.sortDirection === "asc" ? 1 : -1;
            const key = this.sortColumn;
            return docsToSort.sort((a, b) => {
                const primary = this.compareSortValues(
                    this.sortValue(a, key), this.sortValue(b, key)
                ) * dir;
                if (primary !== 0) return primary;
                // Desempates deterministas (independientes de la dirección):
                // monto mayor primero, luego emisión más reciente, luego td_id
                // para estabilidad. Conserva el criterio "lo más grande/reciente
                // arriba" que tenían los desempates por columna anteriores.
                const byAmount = (Number(b.amount) || 0) - (Number(a.amount) || 0);
                if (byAmount !== 0) return byAmount;
                const byDate = (new Date(b.emitted_at).getTime() || 0) - (new Date(a.emitted_at).getTime() || 0);
                if (byDate !== 0) return byDate;
                return (a.td_id || 0) - (b.td_id || 0);
            });
        },
        sortAllDocuments() {
            // El store reemplaza los docs por CLONES al enriquecerlos
            // (setExtraInfoDocumentsByCounterpart) y en cada reload — esos
            // clones no traen isClassifying, así que un rebuild cerraría el
            // árbol abierto. Preservamos el estado por td_id para que el árbol
            // sobreviva (clave para el auto-open del deep-link, que abre sobre
            // el primer set de docs y debe seguir abierto tras el segundo).
            const classifyingIds = new Set(
                this.orderedEntries
                    .filter(entry => entry.isClassifying)
                    .map(entry => entry.td_id)
            )
            const documentsClassified = this.allDocumentsByCounterpart.filter(localDoc => localDoc.accounts.length > 0 && !localDoc.cancelled)
            const documentsNotClassified = this.allDocumentsByCounterpart.filter(localDoc => localDoc.accounts.length == 0 && !localDoc.cancelled)
            const documentsAnnulled = this.allDocumentsByCounterpart.filter(localDoc => localDoc.cancelled)
            const orderedDocsClassified = this.sortPartiallyDocs(documentsClassified)
            const orderedDocsNotClassified = this.sortPartiallyDocs(documentsNotClassified)
            const orderedDocsAnnulled = this.sortPartiallyDocs(documentsAnnulled)
            this.orderedEntries = [...orderedDocsNotClassified, ...orderedDocsClassified, ...orderedDocsAnnulled].map(entry => {
                if (classifyingIds.has(entry.td_id)) {
                    entry.isClassifying = true
                }
                return entry
            })
        },
        changeOrderGeneric(column) {
            if (this.sortColumn != column) {
                this.sortDirection = "order"
                this.sortColumn = column;
            }
            this.changeDirectionData();
            this.sortAllDocuments();
        },
        initDateFirstDayMonthByStr(emittedDate) {
            const stuckTime = 'T00:00:00'
            let date = new Date(emittedDate + stuckTime)
            return new Date(date.getFullYear(), date.getMonth(), date.getDate())
        },
        getFormattedDate(emittedDate, format = 'DD-MM-YYYY') {
            const date = this.initDateFirstDayMonthByStr(emittedDate)
            return moment(date).format(format);
        },
        // addedExtraInfoDocuments() {
        //     this.setExtraInfoDocumentsByCounterpart({
        //         alias: this.counterpart.alias,
        //         rut: this.counterpart.rut,
        //         classifiedAccounts: this.classifiedAccounts,
        //         classifiedAttributes: this.classifiedAttributes,
        //         attributes: this.allAttributes
        //     })
        // },
        searchFilterByStr(entry) {
            const filter = this.searchFilter.trim().toUpperCase();
            if (filter == "") {
                return true
            } else {
                return entry.doc_number.toUpperCase().indexOf(filter) >= 0 ||
                    entry.amount == filter
            }
        },
        allFiltersToEntries() {
            this.orderedEntries = this.orderedEntries.map(entry => {
                entry.isClassifying = false
                entry.visible = this.searchFilterByStr(entry) &&
                    this.changeFilterTable(entry)

                return entry
            })
            if(this.getPaginatedList.length ==0){
                this.actualPage = 1
            }
        }
    },
    computed: {
        ...mapState("classification", ["selectedCounterpart", "selectedHeaderDocsTable",
            "allDocumentsByCounterpart"]),
        getNumberClassifiedByCounterpart() {
            let numberClassified = 0
            this.orderedEntries.map(oEntry => {
                if (oEntry.is_classified_by_counterpart && oEntry.accounts.length > 0) {
                    numberClassified++
                }
            })
            return numberClassified
        },
        getNumberClassifiedByDocument() {
            let numberClassified = 0
            this.orderedEntries.map(oEntry => {
                if (!oEntry.is_classified_by_counterpart && oEntry.accounts.length > 0 && !oEntry.cancelled) {
                    numberClassified++
                }
            })
            return numberClassified
        },
        getNumberTotalDocuments() {
            let totalDocs = 0
            this.orderedEntries.map(oEntry => {
                if (!oEntry.cancelled) {
                    totalDocs++
                }
            })
            return totalDocs
        },
        maxPages: function () {
            const newList = this.orderedEntries.filter(entry => entry.visible)
            if (newList.length % this.itemsPerPage == 0) {
                return newList.length / this.itemsPerPage
            }
            return Math.trunc(newList.length / this.itemsPerPage) + 1
        },
        getPaginatedList: function () {
            const startIndex = (this.actualPage - 1) * this.itemsPerPage
            const endIndex = this.actualPage * this.itemsPerPage
            const newList = this.orderedEntries.filter(entry => entry.visible)
            return newList.slice(startIndex, endIndex)
        },
    },
    mounted() {
        // this.addedExtraInfoDocuments()
        this.changeOrderGeneric('amount')
        if (this.allDocumentsByCounterpart.length > 0) {
            this.setSelectedHeaderDocTable(this.allDocumentsByCounterpart[0].doc_type)
        }
    },
    beforeDestroy() {
        this.setEmptyDocuments({ type: 'all' })
    },
    watch: {
        searchFilter() {
            this.allFiltersToEntries()
        },
        classifiedAccounts() {
            // this.addedExtraInfoDocuments()
            this.sortAllDocuments();
        },
        allDocumentsByCounterpart() {
            // this.addedExtraInfoDocuments()
            this.sortAllDocuments()
        },
        orderedEntries() {
            this.maybeAutoOpen()
        }

    },
    props: {
        types: [],
        classifiedAccounts: [],
        accounts: [],
        classifiedAttributes: [],
        allAttributes: [],
        counterpart: Object,
        // td_id a auto-expandir al cargar (deep-link desde reportes).
        autoOpenDocId: { type: Number, default: null },
    }
};
</script>

<style scoped lang="scss">
.modal_back_caa {
    background-color: #fcfcfd;
}

.gap-custom {
    gap: 24px;
}

.card-custom {
    padding: 12px 24px;
    border-radius: 12px;
    border: 1px solid #EAECF0;
    background: #FFF;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

    .header-card {
        color: #344054;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 12px;
    }

    .progressTextContent {
        color: #475467;
        font-size: 12px;
        line-height: 20px;

        .numberProgress {
            font-weight: 700;
        }

        .textProgress {
            font-weight: 400;
        }
    }
}

.progress-container {
    width: 100%;
    height: 8px;
    background-color: #EAECF0;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #00A9AD;
    transition: width 0.3s ease-in-out;
}

.header_title {
    width: 100%;
    position: relative;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #101828;
    text-align: left;
    display: inline-block;
}

.header_subtitle {
    width: 100%;
    position: relative;
    font-size: 14px;
    line-height: 20px;
    color: #475467;
    text-align: left;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.container_table_main_table {
    border-radius: 8px;
    overflow: auto;
    border: 1px solid #eaecf0;
}

.main_table {
    border-collapse: collapse;
}

.big_table {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
}

.counterpart_table_header {
    background-color: #eaecf0;
    height: 60px;
    width: 100%;
    padding: 12px 20px;
    display: flex;
    flex-direction: row;
}

.absolute-box {
    position: relative;
    min-width: 200px;
    min-width: 300px;

    .absolute-pos {
        position: absolute;
        top: 0;
        left: 0;
        padding: 8px;
        z-index: 5;
    }

    .icon-left {
        height: 20px;
    }

    .input-center {
        margin-left: 28px;
        z-index: 2;
        border-width: 0;
        width: 80%;
        background-color: transparent;
    }

    .input-center:focus {
        outline: none;
        border-color: transparent;
        box-shadow: none;
    }

    .icon-right {
        height: 20px;
        right: 0px;
        left: auto;
    }
}

.search_container {
    border-radius: 8px;
    border: 1px solid var(--Gray-300, #D0D5DD);
    background: var(--Base-White, #FFF);
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.filter_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0;
    flex: 2;
}

.ecs {
    width: 100%;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.clear_button {
    // position: relative;
    // left: -60px;
    // top: 16px;
    // transform: translateY(-50%);
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: #888;
    z-index: 2;
}

$select_transition: 0.1s;

.select_button {
    text-align: center;
    border-radius: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-right: 0.5px solid #ccc;
    border-left: 0.5px solid #ccc;
    margin: 0;
    padding: clamp(5px, 6px, 8px) clamp(10px, 12px, 16px);
    background-color: #ffffff;
    color: #000000;
    transition: all $select_transition ease;
}

.select_button:first-of-type {
    border-left: 1px solid #ccc;
}

.select_button:last-of-type {
    border-right: 1px solid #ccc;
}

.select_button:hover {
    background-color: #c7c7c7;
    color: #000000;
    transition: all $select_transition ease;
}

.first_button {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.last_button {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.black_button {
    background-color: #002e33 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}

.black_button:hover {
    background-color: #185555 !important;
    color: #ffffff !important;
    transition: all $select_transition ease;
}


.table_header_title {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fcfcfd;
    box-sizing: border-box;
    text-align: left;
    font-size: 12px;
}

// Columna ordenable: todo el header es clickeable (no solo el ícono), para que
// aplicar el orden sea obvio. El SortButton indica la dirección activa.
.sortable_header {
    cursor: pointer;
    user-select: none;

    &:hover {
        color: #101828;
    }
}

// La etiqueta puede truncar (columnas angostas como Mes Devengo / Rut); el
// ícono de orden nunca se encoge ni se recorta, así siempre queda visible.
.header_label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sort_btn {
    flex-shrink: 0;
}

.color_gray_text {
    color: #475467;
}

.nobreak {
    white-space: preserve nowrap;
}

.counterpart_row {
    border-top: 1px solid #eaecf0;
    margin-bottom: 10px;
}

// Fila con el árbol de clasificación abierto (lápiz presionado): fondo igual al
// hover de la tabla de Estado de Resultados del reporte financiero
// (--report-accent-bg = #edfdfe). Va en los td para pintar toda la fila.
.counterpart_row.is-classifying > td {
    background-color: #edfdfe;
}

.content-tree {
    border-bottom: 1px solid #EAECF0;
    background: #F9FAFB;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.attribute_name {
    color: #344054;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
}

.circle_pill {
    position: relative;
    border-radius: 16px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    width: min-content;
    min-width: 4em;
}

.blue_pill {
    color: #026AA2;
    border: 1px solid #B9E6FE;
    background: #F0F9FF;
}

.purple_pill {
    color: #5925DC;
    border: 1px solid #D9D6FE;
    background: #F4F3FF;
}

.square_pill {
    position: relative;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    justify-content: center;
    padding: 2px 4px;
    text-align: center;
    font-size: 12px;
    width: min-content;
    min-width: 4em;
}

.pill_sin_clasificar {
    color: #344054;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}

.pill_mother_account {
    line-break: auto;
    color: #475467;
    font-weight: 500;
    line-height: 18px !important;
    font-size: 12px;
}


.grey_pill {
    background-color: #eaecf0;
    border: 1px solid #d0d5dd;
}

.white_pill {
    background-color: #FFF;
    border: 1px solid #D0D5DD;
}

.pill_clasificar {
    position: relative;
    box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fef3f2;
    border: 1px solid #fecdca;
    box-sizing: border-box;
    width: 103px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    gap: 4px;
    text-align: left;
    font-size: 12px;
    color: #b42318;
    font-family: Inter;
    font-weight: 600;
}

.checkSize {
    width: 20px;
    height: 20px;
    // Color del check seleccionado (header "todos" + por fila).
    accent-color: #0097cd;
}

.is-vcentered {
    vertical-align: middle !important;
}

.iconAlign {
    margin-bottom: -2px;
}
</style>
